import(/* webpackMode: "eager" */ "/app/app/(app)/auth/register/page.tsx");
